import React, { memo } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

interface ITaskDatePickerProps {
  /** `YYYY-MM-DD` или `null` — «без даты». */
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
  /** Подпись для читалки: без неё она возьмёт `placeholder` — имя
   *  ПРОТИВОПОЛОЖНОГО состояния («Без срока»). */
  ariaLabel?: string;
  disabled?: boolean;
  size?: 'small' | 'middle';
}

/**
 * Одно поле даты на всю доску задач (ТЗ 0109): обычный календарь antd,
 * `ДД.ММ.ГГГГ`, крестик «снять». Чипов «Сегодня / Завтра / Без срока» больше
 * нет — владелец: «просто календарь».
 *
 * Неделя начинается с понедельника: так устроены локали `moment` `ru` и `pl`,
 * которые `index.tsx` включает при загрузке (`dow: 1`).
 */
export const TaskDatePicker = memo(
  ({
    value,
    onChange,
    placeholder,
    ariaLabel,
    disabled = false,
    size = 'middle',
  }: ITaskDatePickerProps) => (
    <DatePicker
      style={{ width: '100%' }}
      size={size}
      value={value ? moment(value, 'YYYY-MM-DD') : null}
      allowClear
      disabled={disabled}
      format="DD.MM.YYYY"
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={(m) => onChange(m ? m.format('YYYY-MM-DD') : null)}
    />
  ),
);

TaskDatePicker.displayName = 'TaskDatePicker';
